"use strict";

import classNames from "classnames";
import extend from "lodash/extend";
import fromPairs from "lodash/fromPairs";
import map from "lodash/map";
import Popper from "popper.js";
import React from "react";
import {FiMoreVertical, FiPlus, FiTrash} from "react-icons/fi";
import {HiMenuAlt4} from "react-icons/hi";

import Button from "@/components/button/Button.js";
import {Dropdown} from "@/components/dropdown/Dropdown.tsx";
import {Icon} from "@/components/icon/Icon.tsx";
import EditStepForm from "@/legacy/transaction/transaction_script_editor/EditStepForm.jsx";
import StepCommandSelector from "@/legacy/transaction/transaction_script_editor/StepCommandSelector.jsx";
import StepTitleInput from "@/legacy/transaction/transaction_script_editor/StepTitleInput.jsx";
import TransactionUtils from "@/legacy/transaction/TransactionUtils.jsx";
import Utils from "@/legacy/Utils.js";

export default class IfStepForm extends React.Component {
  constructor(props) {
    super(props);
    Utils.autoBindClass(this);
    this.state = {
      selectedBranch: null,
      selectedSubIndex: -1,
      addingBranch: null,
      addInsertIndex: null,
      dropdownKey: null,
    };
  }

  getBranchSteps(branch) {
    return this.props.step.values[branch] || [];
  }

  updateBranch(branch, newSteps) {
    var newValues = extend({}, this.props.step.values, {[branch]: newSteps});
    this.props.onUpdateStepValues(this.props.index, newValues);
  }

  handleSelectSubStep(branch, subIndex) {
    if (this.state.selectedBranch === branch && this.state.selectedSubIndex === subIndex) {
      this.setState({selectedBranch: null, selectedSubIndex: -1});
    } else {
      this.setState({selectedBranch: branch, selectedSubIndex: subIndex});
    }
  }

  handleDeleteSubStep(branch, subIndex) {
    var steps = this.getBranchSteps(branch).concat();
    steps.splice(subIndex, 1);
    this.updateBranch(branch, steps);
    if (this.state.selectedBranch === branch && this.state.selectedSubIndex === subIndex) {
      this.setState({selectedBranch: null, selectedSubIndex: -1});
    }
  }

  handleUpdateSubStepField(branch, subIndex, field, value) {
    var steps = this.getBranchSteps(branch).concat();
    var step = extend({}, steps[subIndex]);
    step.values = extend({}, step.values, {[field]: value});
    step.results = {response_time: -1, error: null};
    steps[subIndex] = step;
    this.updateBranch(branch, steps);
  }

  handleUpdateSubStepTitle(branch, subIndex, title) {
    var steps = this.getBranchSteps(branch).concat();
    steps[subIndex] = extend({}, steps[subIndex], {title: title, results: {response_time: -1, error: null}});
    this.updateBranch(branch, steps);
  }

  handleUpdateSubStepValues(branch, subIndex, newValues) {
    var steps = this.getBranchSteps(branch).concat();
    steps[subIndex] = extend({}, steps[subIndex], {
      values: newValues,
      results: {response_time: -1, error: null},
    });
    this.updateBranch(branch, steps);
  }

  handleAddStart(branch, anchorEl, insertIndex) {
    this.setState({
      addingBranch: branch,
      selectedBranch: null,
      selectedSubIndex: -1,
      addInsertIndex: insertIndex,
      dropdownKey: null,
    });
    var tooltip = document.querySelector("#ifStepSelect-" + this.props.index + "-" + branch);
    if (tooltip) {
      new Popper(anchorEl, tooltip, {placement: "bottom-end"});
    }
  }

  handleAddComplete(branch, step_key) {
    var insertIndex = this.state.addInsertIndex;
    this.setState({addingBranch: null, addInsertIndex: null});
    if (!step_key) {
      return;
    }
    var stepDefsMap = this.props.transactionStepDefsMap;
    var newStep = extend(TransactionUtils.createEmptyStep(step_key), {}, stepDefsMap[step_key]);
    var fieldsAndValues = fromPairs(
      map(newStep.fields, function (f) {
        if (f.type === "BOOLEAN") {
          return [f.name, f.default];
        }
        return [f.name, f.default || ""];
      })
    );
    newStep.values = fieldsAndValues;
    var steps = this.getBranchSteps(branch).concat();
    steps.splice(insertIndex, 0, newStep);
    this.updateBranch(branch, steps);
    this.setState({selectedBranch: branch, selectedSubIndex: insertIndex});
  }

  canAddStep(step_key) {
    if (step_key === "C_AUTH_AND_SETTINGS") {
      return false;
    }
    var stepDefsMap = this.props.transactionStepDefsMap;
    if (stepDefsMap[step_key] && stepDefsMap[step_key].is_deprecated) {
      return false;
    }
    return true;
  }

  getFilteredStepDefs(branch) {
    if (branch === "conditions") {
      return this.props.transactionStepDefs.filter(function (v) {
        return v[1].step_type === "validation";
      });
    }
    return this.props.transactionStepDefs;
  }

  handleDragStart(index, e) {
    e.dataTransfer.effectAllowed = "move";
    try {
      e.dataTransfer.setData("application/json", index.toString());
    } catch (exc) {
      e.dataTransfer.setData("text", index.toString());
    }
  }

  handleDragOver(e) {
    e.preventDefault();
  }

  handleDrop(branch, toIndex, e) {
    e.preventDefault();
    var sourceIndex;
    try {
      sourceIndex = e.dataTransfer.getData("application/json");
    } catch (exc) {
      sourceIndex = e.dataTransfer.getData("text");
    }
    sourceIndex = parseInt(sourceIndex);
    if (sourceIndex === toIndex) {
      return;
    }
    var steps = this.getBranchSteps(branch).concat();
    var stepToMove = steps.splice(sourceIndex, 1)[0];
    steps.splice(toIndex, 0, stepToMove);
    this.updateBranch(branch, steps);
    this.setState({selectedBranch: null, selectedSubIndex: -1});
  }

  handleShowDropdown(branch, index, show) {
    var key = branch + "-" + index;
    if (show) {
      this.setState({dropdownKey: key});
    } else if (this.state.dropdownKey === key) {
      this.setState({dropdownKey: null});
    }
  }

  renderBranch(branch, label, cssClass) {
    var steps = this.getBranchSteps(branch);
    var self = this;
    return (
      <div className={classNames("if-branch", cssClass)}>
        <div className="branch-label pulseTextBodyBold pulse-color-gray-600">{label}</div>
        {steps.length > 0 && (
          <ul className="transaction-steps mb-2">
            {steps.map(function (step, i) {
              var isSelected = self.state.selectedBranch === branch && self.state.selectedSubIndex === i;
              return (
                <li
                  key={i}
                  id={"if-step-" + self.props.index + "-" + branch + "-" + i}
                  className={classNames(step.step_type, {
                    selected: isSelected,
                    error: step.results && step.results.error,
                    success: step.results && !step.results.error && step.results.response_time >= 0,
                  })}
                >
                  <div
                    className="step-row p-2 d-flex align-items-center justify-content-between"
                    onClick={function () {
                      self.handleSelectSubStep(branch, i);
                    }}
                    draggable
                    onDragStart={function (e) {
                      self.handleDragStart(i, e);
                    }}
                    onDragOver={function (e) {
                      self.handleDragOver(e);
                    }}
                    onDrop={function (e) {
                      self.handleDrop(branch, i, e);
                    }}
                  >
                    <div className="num pulseTextBodyBold pulse-border-radius-sm text-center flex-shrink-0">
                      {i + 1}
                    </div>
                    <div
                      className={classNames("description", step.step_type, "pulseTextBodyBold")}
                      style={{flex: "1 1 auto"}}
                    >
                      <a
                        dangerouslySetInnerHTML={{
                          __html: TransactionUtils.formatStepDescription(step, false),
                        }}
                      />
                    </div>
                    <div className="handle d-flex align-items-center">
                      <Dropdown
                        show={self.state.dropdownKey === branch + "-" + i}
                        onToggle={function (show, meta) {
                          meta.originalEvent.stopPropagation();
                          self.handleShowDropdown(branch, i, show);
                        }}
                      >
                        <Dropdown.Toggle variant="ghost" size="fitContent">
                          <Icon icon={FiMoreVertical} size="kpi" />
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          <Dropdown.Item
                            onClick={function (e) {
                              e.stopPropagation();
                              self.handleDeleteSubStep(branch, i);
                            }}
                          >
                            <div className="d-flex align-items-center">
                              <Icon icon={FiTrash} className="me-1" />
                              Delete Step
                            </div>
                          </Dropdown.Item>
                          <Dropdown.Divider />
                          <Dropdown.Item
                            onClick={function (e) {
                              e.stopPropagation();
                              var stepEl = document.querySelector(
                                "#if-step-" + self.props.index + "-" + branch + "-" + i
                              );
                              self.handleAddStart(branch, stepEl, i + 1);
                            }}
                          >
                            <div className="d-flex align-items-center">
                              <Icon icon={FiPlus} className="me-1" />
                              Add Step Below
                            </div>
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                      <Icon icon={HiMenuAlt4} size="kpi" />
                    </div>
                  </div>
                  {isSelected && step.step_def === "C_IF" && (
                    <div className="p-2">
                      <StepTitleInput
                        step={step}
                        monitoringServiceType={self.props.monitoringServiceType}
                        onChange={function (title) {
                          self.handleUpdateSubStepTitle(branch, i, title);
                        }}
                      />
                      <IfStepForm
                        step={step}
                        index={i}
                        transactionStepDefs={self.props.transactionStepDefs}
                        transactionStepDefsMap={self.props.transactionStepDefsMap}
                        onUpdateStepValues={function (subIdx, newVals) {
                          self.handleUpdateSubStepValues(branch, subIdx, newVals);
                        }}
                        htmlElementList={self.props.htmlElementList}
                        onSelectElement={self.props.onSelectElement}
                        onSelectElementCompleted={self.props.onSelectElementCompleted}
                        monitoringServiceType={self.props.monitoringServiceType}
                        onOpenURL={self.props.onOpenURL}
                        enabledFeatureFlags={self.props.enabledFeatureFlags}
                      />
                    </div>
                  )}
                  {isSelected && step.step_def !== "C_IF" && (
                    <div className="p-2">
                      <StepTitleInput
                        step={step}
                        monitoringServiceType={self.props.monitoringServiceType}
                        onChange={function (title) {
                          self.handleUpdateSubStepTitle(branch, i, title);
                        }}
                      />
                      <EditStepForm
                        step={step}
                        htmlElementList={self.props.htmlElementList}
                        onSelectElement={self.props.onSelectElement}
                        onSelectElementCompleted={self.props.onSelectElementCompleted}
                        onUpdateSelectedStepField={function (field, value) {
                          self.handleUpdateSubStepField(branch, i, field, value);
                        }}
                        onOpenURL={self.props.onOpenURL}
                        enabledFeatureFlags={self.props.enabledFeatureFlags}
                      />
                    </div>
                  )}
                </li>
              );
            })}
          </ul>
        )}
        {steps.length === 0 && <div className="pulseTextBody pulse-color-gray-400 mb-2">No steps</div>}
        <div style={{position: "relative", display: "inline-block"}}>
          <StepCommandSelector
            visible={this.state.addingBranch === branch}
            transactionStepDefs={this.getFilteredStepDefs(branch)}
            onCheckStepCanBeAdded={function (key) {
              return self.canAddStep(key);
            }}
            onAddStepComplete={function (key) {
              self.handleAddComplete(branch, key);
            }}
            id={"ifStepSelect-" + this.props.index + "-" + branch}
            defaultActiveKey={branch === "conditions" ? "validation" : "command"}
          />
          <Button
            size="sm"
            variant="secondary"
            onClick={function (e) {
              e.preventDefault();
              e.stopPropagation();
              self.handleAddStart(branch, e.currentTarget, steps.length);
            }}
          >
            <Icon icon={FiPlus} />
            {branch === "conditions" ? "Add Condition" : "Add Step"}
          </Button>
        </div>
      </div>
    );
  }

  render() {
    return (
      <div className="if-step-branches">
        {this.renderBranch("conditions", "IF (all conditions pass):", "conditions")}
        {this.renderBranch("then_steps", "THEN:", "then-branch")}
        {this.renderBranch("else_steps", "ELSE:", "else-branch")}
      </div>
    );
  }
}

IfStepForm.defaultProps = {
  step: {values: {}},
  index: 0,
};
